import React, {FC, ReactNode, ReactElement, useState} from 'react'
import classnames from 'classnames'

// @ts-ignore
import styles from './ReadMoreReadLess.scss'

type ReadMoreReadLessProps = {
  children: ReactNode
  maxLength: number
  className?: string
}

export const ReadMoreReadLess: FC<ReadMoreReadLessProps> = ({
  children,
  maxLength,
  className
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggle = () => {
    setIsExpanded((prev) => !prev)
  }

  const getTextContent = (node: ReactNode): string => {
    if (typeof node === 'string') {
      return node
    } else if (React.isValidElement(node)) {
      const element = node as ReactElement
      if (element.props.children) {
        if (typeof element.props.children === 'string') {
          return element.props.children as string
        } else {
          return getTextContent(element.props.children)
        }
      }
    } else if (Array.isArray(node)) {
      return node.map(getTextContent).join('')
    }
    return ''
  }

  const countChildren = getTextContent(children).length
  const shouldTruncate = countChildren > maxLength
  const ellipsis = shouldTruncate ? '...' : ''
  const truncatedText = isExpanded ? children : getTextContent(children).slice(0, maxLength) + ellipsis
  const buttonText = isExpanded ? '閉じる' : 'もっと読む'

  return (
    <div className={classnames(styles.textContainer, className)}>
      {truncatedText}&nbsp;
      {shouldTruncate && 
        <span className={classnames(styles.button, className)} onClick={toggle} role="button">
          {buttonText}
        </span>
      }
    </div>
  )
}
